"use strict";

var _toConsumableArray = require("/app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_chained_error_1 = require("typescript-chained-error");

var LogLevel_1 = require("../config/LogLevel");

var TimeUtils_1 = require("../util/TimeUtils");

var ParseLogMsg =
/*#__PURE__*/
function () {
  function ParseLogMsg() {
    _classCallCheck(this, ParseLogMsg);
  }

  _createClass(ParseLogMsg, null, [{
    key: "parse",
    value: function parse(level, elems) {
      var outObject = ParseLogMsg.basicLogMsg(level);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = elems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var elem = _step.value;
          outObject = Object.assign({}, outObject, ParseLogMsg.parseElem(elem, outObject));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return outObject;
    }
  }, {
    key: "basicLogMsg",
    value: function basicLogMsg(level) {
      return {
        time_iso: TimeUtils_1.TimeUtils.getUTCISOTime(),
        timestamp: TimeUtils_1.TimeUtils.getTimestamp(),
        level: level,
        level_value: LogLevel_1.LogLevel.LEVELS_VALUES[level]
      };
    }
  }, {
    key: "parseElem",
    value: function parseElem(msgElem, outObj) {
      if (typeof msgElem === "string") {
        return ParseLogMsg.parseString(msgElem, outObj);
      } else if (msgElem instanceof Error) {
        return ParseLogMsg.parseError(msgElem, outObj);
      } else if (typeof msgElem === "object") {
        return ParseLogMsg.parseObject(msgElem, outObj);
      } else {
        return ParseLogMsg.parseOther(msgElem, outObj);
      }
    }
  }, {
    key: "parseString",
    value: function parseString(msg, outObj) {
      return {
        message: (outObj.message ? outObj.message + "; " : "") + msg
      };
    }
  }, {
    key: "parseError",
    value: function parseError(error, outObj) {
      var out = {};
      out.message = (outObj.message ? outObj.message + "; " : "") + (error + "").trim();

      if (outObj.error) {
        out.other_errors = _toConsumableArray(outObj.other_errors || []);
        out.other_errors.push(ParseLogMsg.errorToObj(error));
      } else {
        out.error = ParseLogMsg.errorToObj(error);
      }

      return out;
    }
  }, {
    key: "errorToObj",
    value: function errorToObj(error) {
      if (error instanceof typescript_chained_error_1.default) {
        return Object.assign({
          name: error.name,
          message: error.message,
          stack: error.stack
        }, error.cause ? {
          cause: ParseLogMsg.errorToObj(error.cause)
        } : {});
      } else {
        return {
          name: error.name,
          message: error.message,
          stack: error.stack
        };
      }
    }
  }, {
    key: "parseObject",
    value: function parseObject(msg, outObj) {
      return Object.assign({}, msg);
    }
  }, {
    key: "parseOther",
    value: function parseOther(msg, outObj) {
      return {
        others: [].concat(_toConsumableArray(outObj.others || []), [msg])
      };
    }
  }]);

  return ParseLogMsg;
}();

exports.ParseLogMsg = ParseLogMsg;